<template>
  <div>
    <Summary v-model="maximizeCard" :module_id="51" />
    <vs-tabs v-model="gradeMainTab" class="unique_cstm_tab">
      <!-- {{gradeMainTab}} -->
      <vs-tab label="Student Grade List" v-if="checkGradebookListPermission()">
        <div class="">
          <vx-card title="Filter View" class="mb-4">
            <vs-row>
              <vs-col
                vs-lg="12"
                vs-sm="12"
                vs-xs="12"
                vs-type="flex"
                class="flex-wrap"
                vs-align="center"
              >
                <vs-row>
                  <vs-col vs-lg="3" vs-sm="12" vs-xs="12" class="p-1">
                    <vs-input
                      placeholder="Search"
                      class="w-full"
                      v-model="filterPayload.search"
                      @keyup="searchFun"
                      style="width: 100%"
                    />
                  </vs-col>
                  <vs-col vs-lg="3" vs-sm="12" vs-xs="12" class="p-1">
                    <v-select
                      class="w-full h-full"
                      placeholder="Enter student name to search"
                      appendToBody
                      v-model="filterPayload.client_user_id"
                      :options="studentOpt"
                      :reduce="student => student.client_users_id"
                      label="full_name"
                      :filterable="false"
                      :clearable="false"
                      @search="onStudentSearch"
                      @open="onOpenStudentList"
                      @close="onCloseStudentList"
                    >
                      <template v-slot:selected-option="studentOpt">
                        <img
                          v-if="studentOpt.picture"
                          class="person-img rounded-full"
                          :src="studentOpt.picture"
                        />
                        <img
                          v-else
                          class="person-img rounded-full"
                          src="@/assets/images/pages/user-circle-solid.svg"
                        />
                        {{ studentOpt.full_name }}
                      </template>
                      <template v-slot:option="studentOpt">
                        <img
                          v-if="studentOpt.picture"
                          class="person-img rounded-full"
                          :src="studentOpt.picture"
                        />
                        <img
                          v-else
                          class="person-img rounded-full"
                          src="@/assets/images/pages/user-circle-solid.svg"
                        />
                        {{ studentOpt.full_name }}
                      </template>
                      <template slot="no-options">
                        No results
                      </template>
                      <template #list-footer>
                        <li
                          ref="load_students"
                          class="loader"
                          v-show="student_list_meta.has_next"
                        >
                          Loading more students...
                        </li>
                      </template>
                    </v-select>
                  </vs-col>
                  <vs-col vs-lg="3" vs-sm="12" vs-xs="12" class="p-1">
                    <v-select
                      class="w-full h-full"
                      placeholder="Course Name"
                      appendToBody
                      v-model="filterPayload.course_id"
                      :options="courseOpt"
                      :reduce="course => course.id"
                      label="name"
                      :clearable="false"
                      @open="onOpen"
                      @close="onClose"
                    >
                      <template #list-footer>
                        <li
                          ref="load"
                          class="loader"
                          v-show="course_list_meta.has_next"
                        >
                          Loading more courses...
                        </li>
                      </template>
                    </v-select>
                  </vs-col>
                  <vs-col vs-lg="3" vs-sm="12" vs-xs="12" class="p-1">
                    <v-select
                      class="w-full h-full"
                      placeholder="Course Type"
                      appendToBody
                      v-model="filterPayload.course_type"
                      :options="courseTypeOpt"
                      :reduce="type => type.id"
                      label="text"
                      :clearable="false"
                    ></v-select>
                  </vs-col>

                  <vs-col vs-lg="3" vs-sm="12" vs-xs="12" class="p-1">
                    <v-select
                      class="w-full h-full"
                      placeholder="Marked / Unmarked"
                      appendToBody
                      v-model="filterPayload.marked"
                      :options="[
                        { label: 'Marked', value: 1 },
                        { label: 'Unmarked', value: 2 }
                      ]"
                      :reduce="type => type.value"
                      label="label"
                      :clearable="false"
                    ></v-select>
                    <!-- {{filterPayload.marked}} -->
                  </vs-col>

                  <vs-col
                    vs-type="flex"
                    vs-lg="3"
                    vs-sm="12"
                    vs-xs="12"
                    class="p-1"
                  >
                    <vs-button
                      class="mr-2 includeIcon includeIconOnly"
                      @click="runFilter"
                      >Go</vs-button
                    >
                    <vs-tooltip
                      color="primary"
                      text="Reset Filters"
                      position="top"
                    >
                      <vs-button
                        type="border"
                        icon-pack="feather"
                        icon="icon-refresh-cw"
                        @click="resetFilter"
                      ></vs-button>
                    </vs-tooltip>
                  </vs-col>
                </vs-row>
              </vs-col>
            </vs-row>
          </vx-card>
          <!-- <pre>{{student_grade_list}}</pre> -->
          <vx-card>
            <div
              class="text-right"
              v-if="checkCourseGradebookSharePermission()"
            >
              <div>
                <vs-button
                  v-if="isRowSelected"
                  @click="studentReportShareBulk(selectedCourse)"
                >
                  Bulk Share
                </vs-button>
              </div>
            </div>
            <ag-grid-vue
              class="ag-theme-material w-100 my-4 ag-grid-table"
              @row-selected="CellvalueSelectDeselect"
              :gridOptions="gridOptions"
              :columnDefs="columnDefs"
              :defaultColDef="defaultColDef"
              :rowData="student_grade_list"
              rowSelection="multiple"
              :enableRtl="$vs.rtl"
              colResizeDefault="true"
              :style="{ minHeight: query_page1.limit * 48 + 75 + 'px' }"
              :animateRows="true"
              :floatingFilter="false"
              :pagination="true"
              :paginationPageSize="paginationPageSize"
              :suppressPaginationPanel="true"
              @grid-ready="onGridReady"
              @sortChanged="sortFun"
            />
            <!-- <vs-table 
                  class="grade-table cstm_vuexy_table"
                  multiple
                  v-model="selectedCourse"
                  v-if="student_grade_list"
                  :data="student_grade_list">
                  <template slot="thead">
                
                      <vs-th v-if="checkCourseGradebookSharePermission()">
                          Share to Student
                      </vs-th>
                  </template>

                  <template slot-scope="{data}">
                      <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data" >

                          <vs-td :data="data[indextr].marks">
                              <span class="cstm-status-badge" style="background: rgba(var(--vs-primary), 1); color: #fff;">
                                  <b v-if="data[indextr].final_marks">{{Number(data[indextr].final_marks)}}</b>
                                  <b v-else> N/A </b>
                              </span>
                          </vs-td>


                          <vs-td>
                            <vs-tooltip color="primary" text="Preview" position="top">
                              <vs-button 
                                  type="border"
                                  icon-pack="feather" 
                                  icon="icon-eye"
                                  @click.stop="previewGradebookSidebar(tr)"
                              ></vs-button>
                            </vs-tooltip>
                          </vs-td>
                          <vs-td v-if="checkCourseGradebookSharePermission()">
                            <vs-tooltip :text="data[indextr].shared ? 'Shared' : 'Share'" position="top">
                              <vs-button 
                                  class="includeIcon includeIconOnly"
                                  type="border"
                                  @click="studentReportShare(tr)"
                                  :disabled="data[indextr].shared === 1"
                              >
                                <span class="material-icons share-rotate">reply</span>
                              </vs-button>
                            </vs-tooltip>
                          </vs-td>

                      </vs-tr>
                  </template>
                </vs-table> -->
          </vx-card>
          <vs-row class="mt-2" vs-type="flex" vs-justify="space-between">
            <vs-col
              vs-xs="12"
              vs-sm="6"
              vs-lg="4"
              vs-type="flex"
              vs-justify="start"
              vs-align="center"
            >
              <!-- page limit select view -->
              <ItemsPerTableDropdown
                tableName="grade_list"
                @change="pageLimit => (pageLimitSet = pageLimit)"
              />
            </vs-col>
            <vs-col vs-xs="12" vs-sm="6" vs-lg="8">
              <pagination
                style="float: right"
                :meta="query_page1"
                @page-change="handlePageChange1"
              />
            </vs-col>
          </vs-row>
        </div>
      </vs-tab>
      <vs-tab
        label="Grade Settings"
        v-if="checkGradebookSettingsListPermission()"
      >
        <!-- <pre>{{query_page}}}</pre> -->
        <div class="">
          <vx-card>
            <vs-table
                class="grade-table cstm_vuexy_table"
                multiple
                search
                v-model="selected"
                :data="courseLists">
                    <template slot="header">
                      <h5>
                      Course List
                      </h5>
                    </template>
                    <template slot="thead">
                        <vs-th>
                            Name
                        </vs-th>
                        <vs-th>
                            Description
                        </vs-th>
                        <vs-th>
                            Subject
                        </vs-th>
                        <vs-th>
                            Type
                        </vs-th>
                        <vs-th>
                            Session Frequency
                        </vs-th>
                        <vs-th>
                            Grade Action
                        </vs-th>
                    </template>

                    <template slot-scope="{data}">
                        <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data" >
                        <vs-td >
                            {{tr.name}}
                        </vs-td>

                        <vs-td >
                            {{tr.description}}
                        </vs-td>

                        <vs-td >
                            {{tr.subjects.map((x) => { return x.subject.subject_name })[0] }}
                        </vs-td>

                        <vs-td >
                            <span>
                              {{
                                tr.courseSetting.course_type === 1 ? 'Open' : tr.courseSetting.course_type === 2 ? 'Free' : tr.courseSetting.course_type === 3 ? 'Buy now' : 'Recurring'
                              }}
                            </span>
                        </vs-td>

                        <vs-td >
                            {{getFrequencyNameById(tr.courseSetting.session_frequency)}}
                        </vs-td>

                        <vs-td>
                            <vs-button type="border" icon-pack="feather" icon="icon-settings" @click.stop="openGradationPopup(tr)"></vs-button>
                        </vs-td>
                        </vs-tr>
                    </template>
                </vs-table>
                <pagination
                  class="mt-2"
                  :meta="query_page"
                  @page-change="handlePageChange"
                  style="float: right"
                />
          </vx-card>
        </div>
      </vs-tab>
    </vs-tabs>

    <div
      class="vs-component con-vs-popup vs-popup-primary cstm-modal-popup"
      v-show="gradePopup"
      :class="{ show: gradePopup }"
    >
      <div class="cstm-modal">
        <div class="header">
          <h3>Grade Settings</h3>
          <!-- {{active_course_id}} -->
          <button @click="gradePopup = false" class="close-modal">
            &times;
          </button>
        </div>

        <div class="p-4 modal-content">
          <vs-row
            vs-type="flex"
            vs-align="center"
            class="my-2"
            v-for="(component, index) in gradation_components"
            :key="index"
          >
            <vs-col vs-lg="8" vs-sm="12" vs-xs="12">
              <!-- {{component.isExpandable}} -->
              <vs-checkbox v-model="component.isExpandable">
                {{ component.label }}
              </vs-checkbox>
            </vs-col>
            <vs-col vs-lg="4" vs-sm="12" vs-xs="12">
              <vs-input
                class="w-full"
                label-placeholder="Total %"
                v-model="component.total_percentage"
              />
              <!-- {{component.total_percentage}} -->
            </vs-col>

            <div
              class="w-full mt-4"
              style="background: #eee;"
              v-if="component.isExpandable"
            >
              <vs-row
                vs-type="flex"
                vs-align="center"
                class="my-2 px-4"
                v-for="(opt, index) in component.options"
                :key="index"
              >
                <!-- <pre>{{ opt }}</pre> -->
                <vs-col vs-lg="8" vs-sm="12" vs-xs="12">
                  {{ opt.assignment.title }}
                </vs-col>
                <vs-col vs-lg="4" vs-sm="12" vs-xs="12">
                  <vs-input
                    class="w-full"
                    placeholder="Enter the value in %"
                    v-model="opt.percentage"
                  />
                  <!-- {{opt.percentage}}  -->
                </vs-col>
              </vs-row>
            </div>
            <vs-divider />
          </vs-row>
          <div class="" v-if="checkGradebookSettingsEditPermission()">
            <vs-button class="block ml-auto" @click="createUpdateGradeRule()"
              >Save</vs-button
            >
            <vs-button
              size="size"
              @click="resetGradeRule('Reset')"
              v-if="haveExistingRule"
              >Reset</vs-button
            >
          </div>
        </div>
      </div>
    </div>

    <div class="full-cstm-sidebar mt-107" :class="{ open: previewSidebar }">
      <div class="mt-6 flex items-center justify-between px-6">
        <h4>Preview</h4>
        <feather-icon
          icon="XIcon"
          class="cursor-pointer"
          @click="handlcreateSidebar"
        />
      </div>
      <vs-divider class="mb-0" />

      <div class="p-6 pt-2 sidebar-scrollable-form">
        <div class="">
          <div class="sm:flex flex-wrap justify-between">
            <div>
              <div class="logo_wrapper">
                <h3 style="color: rgba(var(--vs-primary), 1);" class="mb-2">
                  {{ school_name }}
                </h3>
              </div>
              <p>{{ school_address }}</p>
            </div>
            <div>
              <h4 class="mb-2">Report Card</h4>
              <div>
                <label>Date: </label>
                <strong>{{ report_date | dateFormatLocalization }}</strong>
              </div>
            </div>
          </div>
          <vs-divider />

          <div class="sm:flex flex-wrap justify-between">
            <div class="mb-4 sm:mb-0">
              <h5 class="mb-2">Student Details:</h5>
              <div>
                <label>Name: </label>
                <span> {{ student_name }}</span>
              </div>
              <div>
                <label>Instructor: </label>
                <span> {{ teacher_name }}</span>
              </div>
              <div>
                <label>Course: </label>
                <span> {{ course_name }}</span>
              </div>
            </div>
            <div>
              <h5 class="mb-2">Report Details:</h5>
              <div>
                <label>Marks (in %): </label>
                <span>{{ total_mark_obtained }}</span>
              </div>
              <div>
                <label>Grade: </label>
                <span>{{ final_result_grade }}</span>
              </div>
            </div>
          </div>

          <div class="table-responsive cstm_vuexy_table my-4">
            <table
              class="w-full marksheet-table"
              style="border-collapse: collapse"
            >
              <tbody>
                <tr>
                  <th>Name</th>
                  <th>Gradation Component Type</th>
                  <th>Marks</th>
                  <th>( % )</th>
                </tr>

                <tr v-for="(details, index) in attendance_details" :key="index">
                  <td>Attendance Report</td>
                  <td><b>Attendance</b></td>
                  <td>
                    {{ details[Object.keys(details)[0]].marks_obtained }}/{{
                      details[Object.keys(details)[0]].total_mark
                    }}
                  </td>
                  <td>
                    {{ calculatePercentage(details[Object.keys(details)[0]]) }}
                  </td>
                </tr>

                <tr v-for="(details, index) in exam_details[0]" :key="index">
                  <td>{{ details.assignment_title }}</td>
                  <td><b>Exam</b></td>
                  <td>
                    {{ Number(details.marks_obtained) }}/{{
                      Number(details.total_mark)
                    }}
                  </td>
                  <td>{{ calculatePercentage(details) }}</td>
                </tr>

                <tr
                  v-for="(details, index) in homework_details[0]"
                  :key="index"
                >
                  <td>{{ details.assignment_title }}</td>
                  <td><b>Homework</b></td>
                  <td>
                    {{ Number(details.marks_obtained) }}/{{
                      Number(details.total_mark)
                    }}
                  </td>
                  <td>{{ calculatePercentage(details) }}</td>
                </tr>
              </tbody>
              <tfoot>
                <tr>
                  <td>
                    <b style="margin-right:10px"
                      >Result :
                      <span class="passed"> {{ final_result }} </span></b
                    >
                    <b
                      >Grade :
                      <span class="passed"> {{ final_result_grade }} </span></b
                    >
                  </td>
                  <td colspan="2"><b>Total:</b></td>
                  <td>{{ total_mark_obtained }}</td>
                </tr>
              </tfoot>
            </table>

            <vs-divider />

            <h5 class="mb-2">Report:</h5>
            <div>
              <!-- <pre>{{report_details}}</pre> -->
              <vs-row
                v-for="(reportItem, index) in report_details"
                :key="index"
              >
                <vs-col class="p-1" vs-w="12">
                  <b class="mr-4">
                    {{ reportItem.question_title }}
                  </b>
                  <p>{{ reportItem.question_answer }}</p>
                  <p>{{ reportItem.feedback_text }}</p>
                </vs-col>
              </vs-row>
            </div>

            <vs-divider />

            <div class="">
              <h3>Teacher Feedback</h3>
              <p>{{ teacher_feedback }}</p>
            </div>
            <!-- <p><b>N.B:</b> Lorem Ipsum is simply dummy text of the printing and typesetting industry.</p> -->
          </div>
        </div>
      </div>
    </div>
    <div class="bg-overlay"></div>
  </div>
</template>

<script>
import { AgGridVue } from "ag-grid-vue";
import "@/assets/scss/vuexy/extraComponents/agGridStyleOverride.scss";
import FullNameCell from "./Fullname";
import TeacherFullNameCell from "./teacherFullName.vue";
import TotalMarksCell from "./TotalMarksCell";
import ActionCell from "./ActionCell";

import Summary from "../analytics/summeryLIst";

import {
  courseListing,
  createGradeRule,
  getGradeRule,
  updateGradeRule,
  resetGradeRule,
  studentAnswers,
  studentAnswersDetails,
  studentGradebook,
  studentReportShare
} from "@/api/grade";
import { clientList, filterStudentName } from "@/api/client";
import Pagination from "@/components/common/pagination";
import vSelect from "vue-select";
import Vue from "vue";
import { PermissionMiddleware } from "../../../mixins/middleware/PermissionMiddleware";

export default {
  name: "grade",
  components: {
    Pagination,
    vSelect,
    Summary,
    AgGridVue,
    FullNameCell,
    TotalMarksCell,
    ActionCell,
    TeacherFullNameCell
  },
  beforeMount() {
    this.columnDefs = [
      {
        headerName: "",
        minWidth: 60,
        maxWidth: 60,
        field: "isSelected",
        filter: false,
        checkboxSelection: true,
        headerCheckboxSelectionFilteredOnly: true,
        headerCheckboxSelection: true
      },
      {
        headerName: "#",
        field: "row_index",
        filter: false,
        minWidth: 60,
        maxWidth: 120,
        resizable: true,
        editable: false,
        sortable: false,
        valueGetter: "node.rowIndex + 1"
      },
      {
        headerName: "Student Name",
        field: "fullname",
        filter: true,
        minWidth: 150,
        editable: false,
        sortable: true,
        field_type: "system",
        cellRendererFramework: Vue.extend(FullNameCell),
        suppressMovable: false
      },

      {
        headerName: "Course Name",
        field: "course_name",
        minWidth: 150,
        filter: false,
        sortable: true
      },
      {
        headerName: "Course Type",
        field: "course_type",
        filter: false,
        minWidth: 150,
        editable: false,
        sortable: true,
        valueGetter: params => {
          if (params.data.course_type == 1) return "Open";
          else if (params.data.course_type == 2) return "Free";
          else if (params.data.course_type == 3) return "Paid";
          else return "Recurring";
        }
      },
      {
        headerName: "Teacher Name",
        field: "teacher_name",
        filter: false,
        minWidth: 150,
        editable: false,
        sortable: true,
        cellRendererFramework: Vue.extend(TeacherFullNameCell)
      },
      {
        headerName: "Total Marks",
        field: "final_marks",
        filter: false,
        minWidth: 150,
        maxWidth: 150,
        editable: false,
        sortable: true,
        cellRendererFramework: Vue.extend(TotalMarksCell)
      },
      {
        headerName: "Actions",
        field: "actions",
        filter: false,
        minWidth: 50,
        maxWidth: 100,
        editable: false,
        sortable: false,
        cellRendererFramework: Vue.extend(ActionCell),
        cellRendererParams: {
          goMarkList: this.goMarkList,
          goGradeBook: this.goGradeBook,
          previewGradebookSidebar: this.previewGradebookSidebar,
          studentReportShare: this.studentReportShare
        }
      }
    ];
  },
  mixins: [PermissionMiddleware],
  data() {
    return {
      isRowSelected: false,
      gridApi: null,
      gridOptions: {
        accentedSort: true
      },
      defaultColDef: {
        editable: true,
        sortable: true,
        resizable: true,
        suppressMenu: true
        // autoHeight: true
      },
      isRowSelected: false,
      pageLimitSet: 5,
      sorting_obj: {
        field_type: "",
        attribute: "",
        direction: ""
      },
      rowData: null,
      columnDefs: null,
      maximizeCard: true,
      gradeMainTab: 0,
      search: "",
      report_date: "",
      teacher_name: "",
      school_name: "",
      course_name: "",
      student_name: "",
      school_address: "",
      total_mark_obtained: "",
      teacher_feedback: "",
      attendance_details: [],
      homework_details: [],
      exam_details: [],
      report_details: [],
      gradebook_data: null,
      final_result_grade: null,
      final_result: null,
      feedback: false,
      savePreview: false,
      query_page1: {
        total: "",
        limit: 10,
        has_next: false,
        current_page: 1,
        next_page_url: null,
        previous_page_url: ""
      },
      query_page: {
        total: "",
        limit: 10,
        has_next: false,
        current_page: 1,
        next_page_url: null,
        previous_page_url: ""
      },
      haveExistingRule: false,
      active_course_id: null,
      courseLists: null,
      gradePopup: false,
      selected: [],
      gradation_components: [],
      active_assignment_list: null,
      checkBox1: [],
      checkBox2: [],
      selectedCourse: [],
      student_grade_list: null,
      previewSidebar: false,
      filterPayload: {
        course_id: null,
        search: null,
        course_type: null,
        client_user_id: null,
        marked: null //Possible values : if Marked -> '1 / if Unmarked -> '2'
      },
      studentOpt: [],
      student_list_meta: {
        current_page: 1,
        has_next: false,
        limit: 10,
        next_page_url: "",
        previous_page_url: null,
        total: null
      },
      courseOpt: [],
      course_list_meta: {
        current_page: 1,
        has_next: false,
        limit: 10,
        next_page_url: "",
        previous_page_url: null,
        total: null
      },
      courseTypeOpt: [
        { id: 1, text: "Open" },
        { id: 2, text: "Free" },
        { id: 3, text: "Paid" },
        { id: 4, text: "Recurring" }
      ],
      studentSearchValue: null,
      observer: new IntersectionObserver(this.loadMoreCourses),
      observerStudent: new IntersectionObserver(this.loadMoreStudents)
    };
  },
  created() {
    this.getModulePermission("Grade");
  },
  mounted() {
    // this.fetchSubjectList()
    this.gridApi = this.gridOptions.api;
    this.fetchCourseList();
    this.studentAnswers();
  },
  watch: {
    pageLimitSet() {
      this.handlePageChange1(1);
    },
    gradeMainTab(newVal, oldVal) {
      // console.log('newVal', newVal)
      // console.log('oldVal', oldVal)
      if (newVal === 0) {
        this.studentAnswers();
      }
      this.gridOptions.api.sizeColumnsToFit();
    }
  },
  methods: {
    CellvalueSelectDeselect() {
      this.gridApi = this.gridOptions.api;
      const selectedNodes = this.gridApi.getSelectedNodes();
      //
      if (selectedNodes) {
        //
        const selecttedNode = this.gridApi.getSelectedNodes();
        const selectedRows = selecttedNode.map(node => node.data);
        if (selectedRows.length > 1) {
          this.isRowSelected = true;
        } else {
          this.isRowSelected = false;
        }
      } else {
        this.isRowSelected = false;
      }
    },
    paginationPageSize() {
      return this.pageLimitSet;
    },
    onGridReady() {
      this.gridOptions.api.sizeColumnsToFit();
    },
    getCorrectFieldName(colId) {
      let field_name = colId;
      if (colId === "fullname") {
        field_name = "student";
      } else if (colId === "course_name") {
        field_name = "course";
      } else if (colId === "teacher_name") {
        field_name = "teacher";
      }
      console.log("field_name : ", field_name);
      return field_name;
    },
    async sortFun() {
      try {
        const sortState = this.gridOptions.api.getSortModel();
        console.log(sortState);
        if (sortState.length == 0) {
          console.log("No sort active");
        } else {
          this.sorting_obj.field_type = "system";
          this.sorting_obj.attribute = this.getCorrectFieldName(
            sortState[0].colId
          );
          this.sorting_obj.direction = sortState[0].sort;

          console.log(this.sorting_obj);
          this.studentAnswers();
        }
      } catch (e) {
      } finally {
      }
    },
    calculatePercentage(data) {
      const total_mark = data.total_mark;
      const marks_obtained = data.marks_obtained;
      let percentage = 0;
      //   console.log(total_mark, marks_obtained)
      if (total_mark && marks_obtained) {
        percentage = (marks_obtained / total_mark) * 100;
      }
      return percentage.toFixed(2);
    },
    async searchFun() {
      this.fetchListBySearch(this);
    },
    fetchListBySearch: _.debounce(async vm => {
      try {
        vm.studentAnswers(vm.filterPayload);
      } catch (e) {
        console.log(e);
      }
    }, 1500),
    getFrequencyNameById(frequencyId) {
      let frequencyName = "";
      if (frequencyId === 0) {
        frequencyName = "One Time";
      } else if (frequencyId === 1) {
        frequencyName = "Daily";
      } else if (frequencyId === 2) {
        frequencyName = "Weekly";
      } else if (frequencyId === 4) {
        frequencyName = "Monthly";
      }
      return frequencyName;
    },
    studentReportShareBulk(selectedCourse) {
      //console.log(selectedCourse)
      selectedCourse.map(x => {
        // return x.id
        this.studentReportShare(x);
      });
      //console.log('Selected Course Ids for bulk share', selected_course_id)
      // this.studentReportShare(selected_course_id)
    },
    async studentReportShare(course_data) {
      if (!course_data.final_marks) {
        this.$vs.notify({
          title: "Error",
          text: "Please give marks first from marks entry",
          iconPack: "feather",
          icon: "icon-alert-circle",
          color: "danger",
          time: 3000
        });
      } else {
        try {
          const course_id = course_data.id;
          const customer_id = this.$store.getters.customerId;
          let selected_course_id = null;
          let alertText = "";
          if (course_id.length > 0) {
            selected_course_id = course_id;
            alertText = "Gradebook shared with all selected students";
          } else {
            selected_course_id = [course_id];
            alertText = "Gradebook shared with student";
          }
          const payload = {
            id: selected_course_id
          };
          //console.log(payload)
          const { data } = await studentReportShare(customer_id, payload);
          console.log(data);
          this.$vs.notify({
            title: "Success",
            text: alertText,
            iconPack: "feather",
            icon: "icon-alert-circle",
            color: "success",
            time: 3000
          });

          if (typeof selected_course_id === "object") {
            selected_course_id.forEach(ele => {
              this.student_grade_list.filter(
                item => item.id === ele
              )[0].shared = 1;
            });
          } else {
            this.student_grade_list.filter(
              item => item.id === selected_course_id
            )[0].shared = 1;
          }
        } catch (e) {
          console.log(e);
          this.$vs.notify({
            title: "Error",
            text: e,
            iconPack: "feather",
            icon: "icon-alert-circle",
            color: "danger",
            time: 3000
          });
        }
      }
    },
    previewGradebookSidebar(course_data) {
      if (course_data.final_marks) {
        // this.$router.push('gradebook')
        const client_user_id = course_data.client_user_id;
        const course_id = course_data.course_id;
        const payload = {
          client_user_id,
          course_id
        };
        // this.$router.push({name: 'gradebook', params: { payload}})
        this.studentGradebook(payload);
      } else {
        this.$vs.notify({
          title: "Error",
          text: "Please give marks first from marks entry",
          iconPack: "feather",
          icon: "icon-alert-circle",
          color: "danger",
          time: 3000
        });
      }
    },
    async studentGradebook(payload) {
      this.attendance_details = [];
      this.homework_details = [];
      this.exam_details = [];
      this.report_details = [];
      const customer_id = this.$store.getters.customerId;
      const { data } = await studentGradebook(customer_id, payload);
      this.gradebook_data = data.data;
      this.report_details = this.gradebook_data.grade_components.reports.filter(
        x => {
          return x.question_answer !== null;
        }
      );
      //
      //
      this.final_result = this.gradebook_data.grade_info.grade_book_detail.result;
      this.final_result_grade = this.gradebook_data.grade_info.grade_book_detail.grade;
      this.teacher_feedback = this.gradebook_data.grade_info.grade_book_detail.teacher_feedback;
      this.total_mark_obtained = Number(
        this.gradebook_data.grade_info.grade_book_detail.total_mark_obtained
      );
      this.course_name = this.gradebook_data.grade_info.course_name.name;
      this.teacher_name = this.gradebook_data.grade_info.teacher_name;
      this.school_name = this.gradebook_data.grade_info.school_name.brand_company_name;
      this.student_name = `${this.gradebook_data.grade_info.client_user_name.first_name} ${this.gradebook_data.grade_info.client_user_name.last_name}`;
      this.report_date = this.gradebook_data.grade_info.grade_book_detail.created_at;

      const {
        address1,
        address2,
        state,
        city,
        zip
      } = this.gradebook_data.grade_info.school_name.platform_customer_branches;
      this.school_address = `${address1}, ${address2}, ${state}, ${city}, ${zip}`;

      if (this.gradebook_data.grade_components.attendance) {
        Object.values(this.gradebook_data.grade_components.attendance).forEach(
          (val, key) => {
            this.attendance_details.push(val);
          }
        );
      }

      if (this.gradebook_data.grade_components.Homework) {
        Object.values(this.gradebook_data.grade_components.Homework).forEach(
          (val, key) => {
            this.homework_details.push(val);
          }
        );
      }

      if (this.gradebook_data.grade_components.Exam) {
        Object.values(this.gradebook_data.grade_components.Exam).forEach(
          (val, key) => {
            this.exam_details.push(val);
          }
        );
      }

      // const objEntries = Object.entries(this.gradebook_data.grade_components.Exam)

      //
      this.previewSidebar = true;
    },
    handlePageChange(page) {
      //
      const queryPayload = Object.assign({}, this.$route.query);
      queryPayload.page = page;
      queryPayload.limit = 10;
      // this.$router
      //   .replace({
      //     path: '/pages/course-builder/course',
      //     query: queryPayload
      //   })
      //   .catch(() => {})
      // this.fetch_list(queryPayload)
      this.fetchCourseList();
    },
    handlePageChange1(page) {
      //
      const queryPayload = Object.assign({}, this.$route.query);
      queryPayload.page = page;
      queryPayload.limit = this.pageLimitSet;
      // this.$router
      //   .replace({
      //     path: '/pages/course-builder/course',
      //     query: queryPayload
      //   })
      //   .catch(() => {})
      // this.fetch_list(queryPayload)
      this.studentAnswers(queryPayload);
    },
    async studentAnswers(payload) {
      try {
        this.$vs.loading({
          text: "Please wait..."
        });
        const payload1 = {
          ...this.filterPayload,
          ...payload,
          limit: this.pageLimitSet
        };
        const customer_id = this.$store.getters.customerId;
        const { data } = await studentAnswers(
          customer_id,
          payload1,
          this.sorting_obj
        );
        this.student_grade_list = data.data.answerslist;
        this.query_page1 = data.data.meta;
        this.gridOptions.api.sizeColumnsToFit();
      } catch (e) {
        console.log(e);
        this.$vs.notify({
          title: "Error",
          text: "Something went wrong",
          iconPack: "feather",
          icon: "icon-alert-circle",
          color: "danger",
          time: 3000
        });
      } finally {
        this.$vs.loading.close();
      }
    },
    async resetGradeRule(type) {
      try {
        this.$vs.loading({
          text: "Please wait..."
        });
        const { data } = await resetGradeRule(this.active_course_id);
        if (type === "Reset") {
          this.gradation_components = [];
          this.gradePopup = false;
          this.$vs.notify({
            title: "Reset",
            text: "Grade rule reset successfully",
            iconPack: "feather",
            icon: "icon-alert-circle",
            color: "success",
            time: 3000
          });
        }
      } catch (e) {
      } finally {
        this.$vs.loading.close();
      }
    },
    async createUpdateGradeRule() {
      let proceed = true;
      let all_component_sum = 0;
      this.gradation_components.forEach((value, key) => {
        if (value.isExpandable) {
          all_component_sum += Number(value.total_percentage);
        }
      });

      setTimeout(() => {
        if (all_component_sum !== 100) {
          this.$vs.notify({
            title: "Please fill",
            text: "All selected components grade should be equal to 100",
            iconPack: "feather",
            icon: "icon-alert-circle",
            color: "warning",
            time: 3000
          });
          return false;
        } else {
          // this.gradation_components.forEach((value, key) => {
          //   if (value.total_percentage === null) {
          //     this.$vs.notify({
          //       title: 'Error',
          //       text: `Please fill ${  value.label }'s grade`,
          //       iconPack: 'feather',
          //       icon: 'icon-alert-circle',
          //       color: 'warning',
          //       time: 3000
          //     })
          //     return false
          //   }
          // })

          this.gradation_components.forEach((value, key) => {
            //
            if (value.label !== "Attendance") {
              if (value.isExpandable) {
                if (
                  value.options.reduce((a, b) => +a + +b.percentage, 0) !== 100
                ) {
                  proceed = false;
                  this.$vs.notify({
                    title: "Error",
                    text: `All ${value.label} sub component grade must be equal to 100`,
                    iconPack: "feather",
                    icon: "icon-alert-circle",
                    color: "warning",
                    time: 3000
                  });
                  return false;
                }
              }
            }
          });
        }

        if (this.haveExistingRule) {
          setTimeout(async () => {
            if (proceed === true) {
              try {
                // this.$vs.loading({
                //   text: 'Please wait...'
                // })
                const grade_components_arr = [];
                //
                this.gradation_components.forEach((val1, key1) => {
                  //
                  if (val1.label !== "Attendance") {
                    if (val1.isExpandable) {
                      val1.options.forEach((val2, key2) => {
                        grade_components_arr.push({
                          grade_component_id:
                            val2.assignment.assignment_type_id,
                          percentage: val2.percentage
                            ? Number(val2.percentage)
                            : 0,
                          total_percentage: val1.total_percentage
                            ? Number(val1.total_percentage)
                            : 0,
                          assignment_builder_id: val2.assignment_builder_id
                        });
                      });
                    }
                  } else {
                    grade_components_arr.push({
                      grade_component_id: 6,
                      percentage: val1.total_percentage
                        ? Number(val1.total_percentage)
                        : 0,
                      total_percentage: val1.total_percentage
                        ? Number(val1.total_percentage)
                        : 0,
                      assignment_builder_id: 0
                    });
                  }
                });

                const payload = {
                  course_id: this.active_course_id,
                  grade_components: grade_components_arr
                };

                this.resetGradeRule("Update").then(async () => {
                  const { data } = await createGradeRule(payload);
                  this.gradation_components = [];
                  this.gradePopup = false;
                  this.$vs.notify({
                    title: "Updated",
                    text: "Grade rule updated",
                    iconPack: "feather",
                    icon: "icon-alert-circle",
                    color: "success",
                    time: 3000
                  });
                });
              } catch (e) {
                this.$vs.notify({
                  title: "Error",
                  text: "Something went wrong",
                  iconPack: "feather",
                  icon: "icon-alert-circle",
                  color: "danger",
                  time: 3000
                });
              } finally {
                this.$vs.loading.close();
              }
            }
          }, 0);
        } else {
          setTimeout(async () => {
            if (proceed === true) {
              try {
                // this.$vs.loading({
                //   text: 'Please wait...'
                // })
                //
                const grade_components_arr = [];
                //
                this.gradation_components.forEach((val1, key1) => {
                  //
                  if (val1.label !== "Attendance") {
                    if (val1.isExpandable) {
                      val1.options.forEach((val2, key2) => {
                        grade_components_arr.push({
                          grade_component_id:
                            val2.assignment.assignment_type_id,
                          percentage: val2.percentage
                            ? Number(val2.percentage)
                            : 0,
                          total_percentage: val1.total_percentage
                            ? Number(val1.total_percentage)
                            : 0,
                          assignment_builder_id: val2.assignment_builder_id
                        });
                      });
                    }
                  } else {
                    grade_components_arr.push({
                      grade_component_id: 6,
                      percentage: 0,
                      total_percentage: val1.total_percentage
                        ? Number(val1.total_percentage)
                        : 0,
                      assignment_builder_id: 0
                    });
                  }
                });

                const payload = {
                  course_id: this.active_course_id,
                  grade_components: grade_components_arr
                };

                if (grade_components_arr.length) {
                  const { data } = await createGradeRule(payload);
                  this.gradation_components = [];
                  this.gradePopup = false;
                  this.$vs.notify({
                    title: "Created",
                    text: "New grade rule created",
                    iconPack: "feather",
                    icon: "icon-alert-circle",
                    color: "success",
                    time: 3000
                  });
                } else {
                  this.$vs.notify({
                    title: "Ops!",
                    text: "No grade component selected",
                    iconPack: "feather",
                    icon: "icon-alert-circle",
                    color: "warning",
                    time: 3000
                  });
                  this.$vs.loading.close();
                }
              } catch (e) {
                this.$vs.notify({
                  title: "Error",
                  text: "Something went wrong",
                  iconPack: "feather",
                  icon: "icon-alert-circle",
                  color: "danger",
                  time: 3000
                });
              } finally {
                this.$vs.loading.close();
              }
            }
          }, 0);
        }
      }, 500);
    },
    async fetchCourseList() {
      try {
        const payload = {
          tag_ids: [],
          custom: 0,
          limit: this.pageLimitSet
        };
        const customer_id = this.$store.getters.customerId;
        //this.query_page.current_page = 1
        const { data } = await courseListing(
          customer_id,
          payload,
          this.query_page.current_page
        );
        //
        this.courseLists = data.data.courselist;
        this.courseOpt = data.data.courselist;
        this.courseAssignments = this.courseLists.courseAssignments;
        this.query_page = data.data.meta;
        this.course_list_meta = data.data.meta;
        this.gridOptions.api.sizeColumnsToFit();
        //
      } catch (error) {
      } finally {
        this.$vs.loading.close();
      }
    },
    async openGradationPopup(course) {
      this.$vs.loading({
        text: "Please wait..."
      });
      this.active_course_id = course.id;
      const assignment_list = course.courseAssignments;
      this.gradation_components = [];

      //Static grade components until these components are ready in course
      this.gradation_components = [];

      const grade_components = [];

      grade_components.push({
        label: "Attendance",
        data: []
      });

      grade_components.push({
        label: "Homework",
        data: assignment_list.filter(function(x) {
          return x.assignment.assignment_type_id === 2;
        })
      });

      // grade_components.push({
      //   label: 'Report',
      //   data:assignment_list.filter(function (x) { return x.assignment.assignment_type_id === 3 })
      // })

      grade_components.push({
        label: "Exam",
        data: assignment_list.filter(function(x) {
          return x.assignment.assignment_type_id === 4;
        })
      });

      grade_components.forEach((value, key) => {
        if (value.data.length > 0) {
          this.gradation_components.push({
            id: key,
            label: value.label,
            isExpandable: false,
            total_percentage: null,
            options: value.data
          });
        } else if (value.label === "Attendance") {
          this.gradation_components.push({
            id: key,
            label: value.label,
            isExpandable: true,
            total_percentage: null,
            options: value.data
          });
        }
      });

      try {
        const { data } = await getGradeRule(this.active_course_id);

        if (data.data.results.length > 0) {
          this.haveExistingRule = true;
          this.gradation_components.forEach((value, key) => {
            if (value.label !== "Attendance") {
              //let total_percentage = 0
              value.isExpandable = true;
              value.options.forEach(function(value1, key2) {
                Vue.set(
                  value1,
                  "percentage",
                  data.data.results.filter(function(x) {
                    return (
                      x.assignment_type_id === value1.assignment_type_id &&
                      x.assignment_builder_id === value1.assignment_builder_id
                    );
                  })[0].percentage
                );
                //value1.percentage = data.data.results.filter(function (x) { return x.assignment_type_id === value1.assignment_type_id && x.assignment_builder_id === value1.assignment_builder_id })[0].percentage
                value.total_percentage = data.data.results.filter(function(x) {
                  return (
                    x.assignment_type_id === value1.assignment_type_id &&
                    x.assignment_builder_id === value1.assignment_builder_id
                  );
                })[0].total_grade;
                // if (value1.percentage) {
                //   total_percentage += value1.percentage
                // }
              });
            } else {
              value.isExpandable = true;
              value.total_percentage = data.data.results[0].total_grade;
            }
          });
        } else {
          this.haveExistingRule = false;
        }
      } catch (e) {
      } finally {
        this.$vs.loading.close();
      }
      setTimeout(() => {
        this.gradePopup = true;
      }, 500);
    },
    goGradeBook(course_data) {
      if (course_data.final_marks) {
        const client_user_id = course_data.client_user_id;
        const course_id = course_data.course_id;
        const payload = {
          client_user_id,
          course_id
        };
        this.$router.push({ name: "gradebook", params: { payload } });
        // this.$router.push('gradebook')
        // this.studentGradebook(payload)
        //
      } else {
        this.$vs.notify({
          title: "Error",
          text: "Please give marks first from marks entry",
          iconPack: "feather",
          icon: "icon-alert-circle",
          color: "danger",
          time: 3000
        });
      }
    },
    goMarkList(course_data) {
      const client_user_id = course_data.client_user_id;
      const answer_list_id = course_data.id;
      const header_info = {
        student_name: course_data.student_name,
        course_name: course_data.course_name,
        teacher_name: course_data.teacher_name,
        course_type:
          course_data.course_type === 1
            ? "Open"
            : course_data.course_type === 2
            ? "Free"
            : course_data.course_type === 3
            ? "Buy now"
            : "Recurring"
      };

      if (course_data.grade_setting > 0) {
        this.$router.push({
          name: "marklist",
          params: { answer_list_id, client_user_id, header_info }
        });
      } else {
        this.$vs.notify({
          title: "Error",
          text:
            "Please set the gradation rules from grade settings to give course marks",
          iconPack: "feather",
          icon: "icon-alert-circle",
          color: "danger",
          time: 3000
        });
      }
    },
    handlcreateSidebar() {
      this.previewSidebar = false;
    },
    async onStudentSearch(search, loading) {
      if (search.length > 2) {
        loading(true);
        this.studentSearchValue = search;

        this.searchStudent(loading, search, this);
      }
    },
    // eslint-disable-next-line no-undef
    searchStudent: _.debounce(async (loading, search, vm) => {
      const customer_id = vm.$store.getters.customerId;

      try {
        // Fetch the response from search query
        const response = await filterStudentName(customer_id, { name: search });

        vm.studentOpt = response.data.data.clientUser.map(user => {
          return {
            ...user.basic_details,
            full_name: `${user.basic_details.first_name} ${user.basic_details.middle_name} ${user.basic_details.last_name}`
          };
        });

        if (vm.studentOpt.length > 0) {
          vm.filterPayload.client_user_id = null;
        }

        vm.student_list_meta = response.data.data.meta;

        loading(false);
      } catch (e) {}
    }, 350),

    async runFilter() {
      await this.studentAnswers(this.filterPayload);
    },
    async resetFilter() {
      this.filterPayload = {
        course_id: null,
        course_type: null,
        client_user_id: null
      };

      await this.studentAnswers();
    },
    async onOpen() {
      if (this.course_list_meta.has_next) {
        await this.$nextTick();
        this.observer.observe(this.$refs.load);
      }
    },
    async onOpenStudentList() {
      if (this.student_list_meta.has_next) {
        await this.$nextTick();
        this.observerStudent.observe(this.$refs.load_students);
      }
    },
    onClose() {
      this.observer.disconnect();
    },
    onCloseStudentList() {
      this.observerStudent.disconnect();
    },
    async loadMoreCourses([{ isIntersecting, target }]) {
      const customer_id = this.$store.getters.customerId;

      if (isIntersecting) {
        const ul = target.offsetParent;
        const scrollTop = target.offsetParent.scrollTop;

        try {
          const response = await courseListing(
            customer_id,
            undefined,
            this.course_list_meta.current_page + 1
          );
          this.courseOpt.push(...response.data.data.courselist);

          this.course_list_meta = response.data.data.meta;
        } catch (e) {}

        await this.$nextTick();
        ul.scrollTop = scrollTop;
      }
    },
    async loadMoreStudents([{ isIntersecting, target }]) {
      const customer_id = this.$store.getters.customerId;

      if (isIntersecting) {
        const ul = target.offsetParent;
        const scrollTop = target.offsetParent.scrollTop;

        try {
          const response = await filterStudentName(
            customer_id,
            { name: this.studentSearchValue },
            this.student_list_meta.current_page + 1
          );

          const formattedData = response.data.data.clientUser.map(user => {
            return {
              ...user.basic_details,
              full_name: `${user.basic_details.first_name} ${user.basic_details.middle_name} ${user.basic_details.last_name}`
            };
          });

          this.studentOpt.push(...formattedData);
          this.student_list_meta = response.data.data.meta;
        } catch (e) {}

        await this.$nextTick();
        ul.scrollTop = scrollTop;
      }
    }
  }
};
</script>

<style>
.vue-form-wizard.md .wizard-navigation .wizard-nav .stepTitle.active {
  font-weight: bold;
}
.grade-table .vs-table--thead tr {
  background: #f8f8f8;
}
.grade-table tr {
  box-shadow: 0 0 5px 1px rgba(0, 0, 0, 0.2);
}
</style>
<style scoped>
.loader {
  text-align: center;
  color: #bbbbbb;
}
</style>
